const elementsOverlap = {
  // detects if two elements overlap
  methods: {
    elementsOverlap(el1, el2) {
      const domRect1 = el1.getBoundingClientRect()
      const domRect2 = el2.getBoundingClientRect()

      return !(
        domRect1.top > domRect2.top ||
        domRect1.right < domRect2.left ||
        domRect1.bottom < domRect2.top ||
        domRect1.left > domRect2.right
      )
    },
  },
}

export { elementsOverlap }
